import React, {FC} from 'react';
import styled from 'styled-components';

import {ViewerPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {isLinkedConversationFirstOfKind} from '../../../../helpers/models/linkedConversationsHelpers';
import {ActivityModel, DetailedActivityModel} from '../../../../models/api/activityModel';
import {LinkedConversationsViewerContainer} from './linkedConversation/linkedConversationsViewerContainer';

/*
 * Props.
 */

interface LinkedConversationActivityProps {
  panelId: ViewerPanelId;
  activity: DetailedActivityModel;
  activities: ReadonlyArray<ActivityModel>;
  activityIndex: number;
  hasLinkedConversations: boolean;
}

/*
 * Style.
 */

const StyledLinkedConversationViewerContainerDiv = styled.div<{$isFirstOfKind: boolean}>`
  margin-top: ${(p) => (p.$isFirstOfKind ? '16px' : 0)};
`;

/*
 * Component.
 */

export const LinkedConversationActivity: FC<LinkedConversationActivityProps> = (props) => {
  const {activities, activity, activityIndex, hasLinkedConversations} = props;
  const previousActivity = activities[activityIndex - 1];
  const isFirstOfKind = isLinkedConversationFirstOfKind(activity, previousActivity);

  if (!hasLinkedConversations) {
    return null;
  }

  return (
    <StyledLinkedConversationViewerContainerDiv $isFirstOfKind={isFirstOfKind}>
      <LinkedConversationsViewerContainer
        panelId={props.panelId}
        activity={activity}
        isFirstOfKind={isFirstOfKind}
      />
    </StyledLinkedConversationViewerContainerDiv>
  );
};
